<template>
  <div class="basic-info">
    <el-form
      label-position="left"
      label-width="5rem"
      :rules="orgRules"
      :model="org"
      ref="orgForm"
      v-if="isEdit"
    >
      <div class="edit-view">
        <div class="title">
          <div v-if="this.status.name == 'edit'">{{ org.name }}</div>
          <div v-else>添加新部门</div>
        </div>

        <el-form-item label="部门类型">
          <el-radio-group v-model="org.type">
            <el-radio-button :label="0">业务</el-radio-button>
            <el-radio-button :label="1">职能</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="`隶属部门`" class="auto-height" prop="parentId">
          <treeselect
            noOptionsText="未找到对应数据"
            noResultsText="未找到对应数据"
            v-model="parentId"
            value-consists-of="BRANCH_PRIORITY"
            :multiple="false"
            :options="orgs"
            :normalizer="normalizer"
            :flatten-search-results="false"
            :value="config"
            placeholder="请选择部门"
          />
        </el-form-item>
        <el-form-item
          label="部门名称"
          class="auto-height name-form"
          prop="name"
        >
          <el-input
            v-model="org.name"
            placeholder="请输入部门名称"
            clearable
          ></el-input>
          <div class="form-tip">
            仅支持中文、英文、数字、_、-，不超过30个字符
          </div>
        </el-form-item>
        <el-form-item label="部门简称">
          <el-input
            v-model="org.alias"
            placeholder="请输入部门简称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="部门标签" prop="tag" >
          <el-select v-model="org.tag" clearable placeholder="请选择部门标签">
            <el-option
              v-for="item in orgOptions"
              :key="item.option"
              :label="item.option"
              :value="item.option"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-radio-group v-model="org.status">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <el-tooltip
            placement="top"
            popper-class="custom-tooltip"
            effect="light"
          >
            <div slot="content">不启用后，该组织将不可用！</div>
            <svg-icon class="tip-svg" icon-class="tip" />
          </el-tooltip>
        </el-form-item>
        <el-form-item label="办公电话" prop="phoneNumber">
          <el-input
            v-model="org.phoneNumber"
            placeholder="请输入办公电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="org.email"
            placeholder="请输入邮箱"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="transfer-form-item" label="权限组">
          <div class="transfer-select" @click="openFiltrate">
            <span class="placeholder" v-if="!roles.length">请选择权限组</span>
            <div
              class="select-item"
              v-for="(item, index) in roles"
              v-show="index < 2"
              :key="index"
            >
              <span>{{ item }}</span>
              <div
                class="del-fixed-item"
                @click.stop="delPermissionItem(index)"
              >
                <svg-icon icon-class="close-ico"></svg-icon>
              </div>
            </div>
            <div v-if="roles.length > 2">...</div>
            <div class="suffix">
              <i
                class="el-icon-circle-close"
                @click.stop="permissionForm = []"
                v-if="roles.length"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="{ 'inline-block': !roles.length }"
              ></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="办公地址" class="form-address auto-height">
          <el-input
            v-model="org.address"
            placeholder="请输入办公地址"
            @keyup.enter.native="changeAddress()"
            clearable
          ></el-input>
          <baidu-map
            :center="center"
            :zoom="zoom"
            @ready="handlerMap"
            id="allmap"
            :scroll-wheel-zoom="true"
            v-if="org.address"
          ></baidu-map>
        </el-form-item>
        <el-form-item label="备注" class="auto-height">
          <el-input
            type="textarea"
            v-model="org.description"
            maxlength="200"
            show-word-limit
            resize="none"
          ></el-input>
          <div class="form-tip">
            仅支持中文、英文、数字、_、-，不超过200个字符
          </div>
        </el-form-item>
        <div class="group-btn">
          <el-button type="primary" @click="sumitInfo" :loading="isLoading"
            >保存</el-button
          >
          <el-button @click="cancel">取消</el-button>
        </div>
      </div>
    </el-form>
    <el-form
      class="info-view"
      :model="organization"
      label-position="left"
      label-width="5rem"
      v-else
    >
      <div class="title">
        <span>{{ organization.name }}</span>
        <div class="edit-btn" @click="sumitEdit">管理</div>
      </div>

      <el-form-item label="部门类型">{{ organization.type }}</el-form-item>
      <el-form-item label="部门名称">{{ organization.name }}</el-form-item>
      <el-form-item label="部门简称">{{
        organization.alias | nullValue
      }}</el-form-item>
      <el-form-item label="部门标签">{{
        organization.tag | nullValue
      }}</el-form-item>
      <el-form-item label="是否启用">
        <div class="status">
          <!-- <svg-icon
            class="svg"
            v-if="!organization.status"
            icon-class="status-close"
          />
          <svg-icon class="svg" v-else icon-class="success" /> -->
          <span :class="organization.status ? 'success' : 'close'"
            >{{ organization.status ? "是" : "否" }}
          </span>
        </div>
      </el-form-item>
      <el-form-item label="办公电话">{{
        organization.phoneNumber | nullValue
      }}</el-form-item>
      <el-form-item label="邮箱">{{
        organization.email | nullValue
      }}</el-form-item>
      <el-form-item label="权限组" v-if="organization.roles">
        <span
          class="permission-item"
          v-for="(item, index) in organization.roles"
          :key="index"
          v-show="organization.roles.length"
          >{{ item.name }}</span
        >
        <span v-show="!organization.roles.length">—</span>
      </el-form-item>
      <el-form-item label="创建时间">{{
        organization.creationTime | timeFommater
      }}</el-form-item>
      <el-form-item label="详细地址">{{
        organization.address | nullValue
      }}</el-form-item>
      <el-form-item label="备注">{{
        organization.description | nullValue
      }}</el-form-item>
    </el-form>
    <el-dialog
      title="选择权限"
      :visible.sync="isFiltrateShow"
      width="800px"
      :before-close="permissionGroupClose"
      custom-class="filter-dialog"
    >
      <el-transfer
        filterable
        :titles="['可选择权限组', '已加入权限组']"
        filter-placeholder="请输入权限组名称"
        v-model="permissionForm"
        :data="tabTitData"
        :filter-method="filterMethod"
      ></el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPermissionItems">取消</el-button>
        <el-button type="primary" @click="isFiltrateShow = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  createOrg,
  updateOrg,
  updateOrgRoles,
  getOrgAllTree,
} from "@/http/api/organization";

import { validatePhone, validateEmail } from "@/utils/validate";
import { deepCopy } from "@/utils/deepCopy";
import { getAllRoles } from "@/http/api/role";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getOuSettings } from "@/http/api/system";
import { tree } from "@/utils/tree";
export default {
  props: {
    selectedId: { type: String }, //被选中的部门id
    operation: { type: Object }, //操作类型
    organization: { type: Object }, // 组织部门
    permissionRoles: { type: Array }, //组织权限
  },
  components: {
    Treeselect,
  },
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不正确"));
      } else {
        callback();
      }
    };
    const validateOrgEmail = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validateEmail(value)) {
        callback(new Error("邮箱输入不正确"));
      } else {
        callback();
      }
    };
    return {
      org: {
        type: 0,
        status: true,
      },
      parentId: null,
      status: {},
      isEdit: false,
      center: { lng: 109.45744048529967, lat: 36.49771311230842 },
      zoom: 13,
      isLoading: false,
      orgs: [],
      orgRules: {
        phoneNumber: [
          {
            required: false,
            isClear: false,
            trigger: "blur",
            validator: validatePhoneNumber,
          },
        ],
        email: [
          {
            required: false,
            isClear: false,
            trigger: "blur",
            validator: validateOrgEmail,
          },
        ],
        tag: [{ required: true, trigger: "change", message: "请选择标签" }],
        name: [{ required: true, trigger: "blur", message: "请输入部门名称" }],
      },
      originalRoles: [],
      rolesAll: [], // 所有权限组
      tabTitData: [],
      permissionForm: [],
      orgOptions: [],
      isFiltrateShow: false,
      permissions: this.$store.getters.permissions,
      config: ["disabled-checked"],
      normalizer(node) {
        if (node.data && node.data.id) {
          return {
            id: node.data.id,
            label: node.data.name,
            children: node.children,
          };
        }
      },
    };
  },
  watch: {
    selectedId(newValue, oldValue) {
      this.parentId = newValue?newValue:null;
      console.log(this.parentId,"this.parentId");
    },
    operation(newValue, oldValue) {
      this.status = newValue;
      console.log(111,newValue,222,oldValue,333,this.status);
      if(this.status.name=="createTop"){
        this.parentId = null
      }else if(this.status.name=="createSubordinate"){
        this.parentId = this.status.id
      }
    },
  },
  computed: {
    roleIds() {
      let ids = [];
      if (this.permissionForm.length) {
        this.permissionForm.map((item) => {
          ids.push(item.split(" ")[0]);
        });
      }
      return ids;
    },
    roles() {
      let names = [];
      if (this.permissionForm.length) {
        this.permissionForm.map((item) => {
          names.push(item.split(" ")[1]);
        });
      }
      return names;
    },
  },
  mounted() {
    this.getRoles();
    this.getOrgSettings();
    this.getOrgs();
    setTimeout(() => {
      this.permissionForm = this.permissionRoles;
    }, 1000);
  },
  methods: {
    // 获取用户配置字段
    getOrgSettings() {
      getOuSettings().then((res) => {
        res.result.map((item) => {
          if (item.name == "Deer.OrganizationUnit.Collection.Tag") {
            this.orgOptions = item.value;
          }
        });
      });
    },
    getRoles() {
      getAllRoles().then((res) => {
        this.rolesAll = res.result.items;
        this.rolesAll.forEach((item, index) => {
          this.tabTitData.push({
            label: item.name,
            key: item.id + " " + item.name,
          });
        });
      });
    },
    cancelPermissionItems() {
      this.permissionForm = this.originalRoles;
      this.isFiltrateShow = false;
    },
    // 获取组织
    getOrgs() {
      getOrgAllTree({ loadMode: 2 }).then((res) => {
        this.orgs = tree(res.result.items,this.selectedId);
      });
    },
    permissionGroupClose() {
      this.isFiltrateShow = false;
    },
    delPermissionItem(index) {
      this.permissionForm.splice(index, 1);
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    // 打开权限组窗口
    openFiltrate() {
      this.isFiltrateShow = true;
    },
    // 点击管理按钮
    sumitEdit() {
      if (this.permissions["RocketIdentity.OrganizationUnits.Update"]) {
        this.status.name = "edit";
        this.permissionForm = this.permissionRoles;
        this.org = deepCopy(this.organization);
        this.parentId = this.organization.parentId?this.organization.parentId:null;
        this.org.type = this.org.type == "业务" ? 0 : 1;
        this.isEdit = true;
        this.getOrgs()
      } else {
        this.$message.warning({
          message: `您暂无部门管理权限`,
          showClose: true,
        });
      }
    },
    // 关闭管理页
    cancel() {
      this.isEdit = false;
    },
    // 输入地址
    changeAddress() {
      this.handlerMap({ BMap });
    },
    // 解析地址
    handlerMap({ BMap }) {
      var map = new BMap.Map("allmap"); // 创建Map实例
      let lng = this.organization.longitude,
        lat = this.organization.latitude;
      if (lng && lat) {
        map.centerAndZoom(new BMap.Point(lng, lat), 13);
      } else {
        map.centerAndZoom("郑州", 13);
      }
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      var myGeo = new BMap.Geocoder();
      // 将地址解析结果显示在地图上,并调整地图视野
      var that = this;
      if (that.org.address) {
        var local = new BMap.LocalSearch(map, {
          renderOptions: { map: map },
        });
        local.search(this.org.address);
        local.setSearchCompleteCallback(function (results) {
          //console.log(results, "results");
          let res = results.Hr;
          if (res.length) {
            that.org.latitude = res[0].point.lat;
            that.org.longitude = res[0].point.lng;
          }
        });
      }
      var geoc = new BMap.Geocoder();
      map.addEventListener(
        "click",
        function (e) {
          var pt = e.point;
          geoc.getLocation(pt, function (rs) {
            that.org.latitude = rs.point.lat;
            that.org.longitude = rs.point.lng;
            that.org.address = rs.address;
          });
        },
        { passive: false }
      );
    },
    // 点击保存按钮
    sumitInfo() {
      //console.log(this.org, 1111);
      this.$refs.orgForm.validate((valid) => {
        if (valid) {
          this.isEdit = false;
          this.isLoading = true;
          if (this.parentId) {
            this.org.parentId = this.parentId;
          } else {
            this.org.parentId = null;
          }
          //console.log();
          if (this.status.name == "edit") {
            this.org.roles = this.roleIds;
            let data = {
              name: this.org.name,
              alias: this.org.alias,
              description: this.org.description,
              tag: this.org.tag,
              phoneNumber: this.org.phoneNumber,
              email: this.org.email,
              address: this.org.address,
              longitude: this.org.longitude,
              latitude: this.org.latitude,
              licenseKey: this.org.licenseKey,
              type: this.org.type,
              expanded: this.org.expanded,
              status: this.org.status,
              parentId: this.org.parentId,
              roles: this.org.roles,
              concurrencyStamp: this.org.concurrencyStamp,
            };
            updateOrg(this.organization.id, data)
              .then((res) => {
                if (res.code == 10200) {
                  this.$message.success({
                    message: "修改成功",
                    showClose: true,
                  });
                  this.$store.dispatch("ChangePermissions");
                  this.$emit("updateOrg", this.org);
                  this.getOrgs()
                }
                this.isLoading = false;
              })
              .catch((err) => {
                this.isLoading = false;
              });
          } else {
            this.org.roles = this.roleIds;
            createOrg(this.org)
              .then((res) => {
                if (res.code == 10200) {
                  this.$message.success({
                    message: "添加成功",
                    showClose: true,
                  });
                  this.getOrgs()
                  this.$emit("createOrg", this.org);
                }
                this.isLoading = false;
                this.getOrgs();
              })
              .catch((err) => {
                this.isLoading = false;
              });
          }
        }
      });
    },
    createOrg() {
      this.org = {
        type: 0,
        status: true,
      };
      this.permissionForm = [];
      this.isEdit = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.basic-info {
  padding: 20px 15px 0 18px;
  text-align: left;
  ::v-deep .vue-treeselect {
    margin-left: 0;
    width: 330px;
    .vue-treeselect__control {
      border-radius: 4px;
    }
    .vue-treeselect__menu {
      width: 330px;
    }
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 8px;
    font-size: 14px;
    font-weight: bold;
    line-height: 40px;
    color: #000;

    .edit-btn {
      font-size: 14px;
      font-weight: 400;
      color: $--color-primary;
      cursor: pointer;
    }
  }
  .status {
    @include flex(row, center);
    .svg {
      margin-right: 5px;
    }
    .success {
      color: #0abf5b;
    }
    .close {
      color: #f44242;
    }
  }
  .info-view {
    .el-form-item {
      margin-bottom: 12px;

      .permission-item {
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .edit-view {
    .el-form-item {
      width: 425px;

      .el-textarea,
      .el-select,
      .el-input {
        width: 330px;
      }

      .tip-svg {
        position: relative;
        top: -1px;
        margin-left: 5px;
        width: 14px;
        height: 14px;
        color: #9e9e9e;
      }
    }

    .form-address {
      width: 95%;
      margin-top: 0;

      .el-input {
        width: 100%;
      }

      #allmap {
        width: 100%;
        height: 200px;
        margin-top: 5px;
      }
    }

    .group-btn {
      margin: 12px 0 0 5rem;
    }
  }
}
</style>